"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSet = void 0;
const zod_1 = require("zod");
const ad_definition_1 = require("./ad-definition");
const credential_definition_1 = require("./credential-definition");
const entity_id_1 = require("./entity-id");
const schedule_1 = require("./schedule");
// TODO: budget and additional fields
exports.AdSet = zod_1.z.object({
    /**
     * Unique id of the ad-set. Unset if the ad-set has not been stored.
     */
    id: entity_id_1.EntityId.optional(),
    /**
     * Names this ad set. If there are two ad sets with the same name inside a Campaign the first one is ignored
     * ("last wins").
     */
    name: zod_1.z.string(),
    /**
     * Whether this ad-set is allowed to be served to users.
     */
    active: zod_1.z.boolean().default(true),
    /**
     * A list of credential slugs. All must be possessed by the consumer in order to receive this ad set. In the future.
     * Will be evolved in the future to support richer conditions (in particular: "or semantics").
     */
    audience: credential_definition_1.CredentialDefinition.array(),
    /**
     * Timing settings of the ad-set.
     */
    schedule: schedule_1.Schedule,
    /**
     * List of ads.
     */
    ads: ad_definition_1.AdDefinition.array(),
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWQtc2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL2FkLXNldC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBdUI7QUFFdkIsbURBQThDO0FBQzlDLG1FQUE4RDtBQUM5RCwyQ0FBc0M7QUFDdEMseUNBQXFDO0FBRXJDLHFDQUFxQztBQUN4QixRQUFBLEtBQUssR0FBRyxPQUFDLENBQUMsTUFBTSxDQUFDO0lBQzVCOztPQUVHO0lBQ0gsRUFBRSxFQUFFLG9CQUFRLENBQUMsUUFBUSxFQUFFO0lBQ3ZCOzs7T0FHRztJQUNILElBQUksRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFO0lBQ2hCOztPQUVHO0lBQ0gsTUFBTSxFQUFFLE9BQUMsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDO0lBQ2pDOzs7T0FHRztJQUNILFFBQVEsRUFBRSw0Q0FBb0IsQ0FBQyxLQUFLLEVBQUU7SUFDdEM7O09BRUc7SUFDSCxRQUFRLEVBQUUsbUJBQVE7SUFDbEI7O09BRUc7SUFDSCxHQUFHLEVBQUUsNEJBQVksQ0FBQyxLQUFLLEVBQUU7Q0FDMUIsQ0FBQyxDQUFBIn0=